var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopSepurationLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 849,
    height: 6,
    viewBox: "0 0 849 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.626432 3L3.51318 5.88675L6.39994 3L3.51318 0.113249L0.626432 3ZM848.4 3L845.513 0.113249L842.626 3L845.513 5.88675L848.4 3ZM3.51318 3.5H845.513V2.5H3.51318V3.5Z",
    fill: "#094E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSepurationLine);
export default __webpack_public_path__ + "static/media/desktop-sepuration-line.96bfd780078afd67165e17848bca49dd.svg";
export { ForwardRef as ReactComponent };